import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import repos from './modules/repos'
import packages from './modules/packages'
import releases from './modules/releases'
import transactions from './modules/transactions'
import appFrame from './modules/appFrame'
import licensing from './modules/licensing'
import stats from './modules/stats'
import status from './modules/status'
import alerts from './modules/alerts'
import HTTP from '../api/http-common'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    repos: repos.module(HTTP),
    packages: packages.module(HTTP),
    releases: releases.module(HTTP),
    transactions: transactions.module(HTTP),
    appFrame: appFrame,
    licensing: licensing.module(HTTP),
    stats: stats.module(HTTP),
    status: status.module(HTTP),
    alerts: alerts.module(HTTP),
  },
  strict: debug,
  plugins: [createPersistedState({
    paths: ['status.showLatestUpdate', 'status.latestVersionUpdate', 'status.latestVersionUpdateSeen'],
  })],
})

store.dispatch('getStatus')
store.dispatch('getAlerts')

export default store
